import { __assign } from "tslib";
import types from '../types';
import * as _isEqual from 'lodash/isEqual';
var initialState = {
    byId: {}
};
function chatroomsPresenceReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case types.SET_PARTICIPANTS_PRESENCE:
            if (!_isEqual(state.byId, action.chatroomsParticipants)) {
                return {
                    byId: __assign({}, action.chatroomsParticipants)
                };
            }
            break;
        case types.UPDATE_PARTICIPANTS_PRESENCE:
            var newStateById = Object
                .keys(action.chatroomsParticipants)
                .reduce(function (newPartialStateById, chatroom) {
                var _a;
                return (__assign(__assign(__assign({}, state.byId), newPartialStateById), (_a = {}, _a[chatroom] = __assign(__assign({}, state.byId[chatroom]), action.chatroomsParticipants[chatroom]), _a)));
            }, {});
            return {
                byId: __assign(__assign({}, state.byId), newStateById)
            };
        default:
            break;
    }
    return state;
}
export { chatroomsPresenceReducer };
